export default "__VITE_ASSET__DkzsRb1g__"